<template>
  <div class="wrapper">
    <pulldown-page
      class="withdraw-result"
      background="white"
      :refresh="pulldown"
      is-scroll
      color="#333333"
      :style="{ 'padding-top': (statusMapping === '3' ? 0 : statusBarHeight || 0) + 'px'}"
    >
      <p slot="pulling" class="refresh">下拉可刷新</p>
      <p slot="loosing" class="refresh">释放可刷新</p>
      <template v-if="statusMapping === '3'">
        <navigation
          arr-theme="black"
          :sticky="false"
          :theme="{ background: 'transparent',color: '#fff'}"
          customClickEvent
          @click="navigateToHome"
        ></navigation>
        <template v-if="userInfo.hasDiversion">
          <!-- 根据/result/v1/page接口数据决定展示哪个banner -->
          <template v-if="bannerStyle === 'UNUSED_PRIVILEGE'">
            <unused-privilege
              flow="loan"
              :amount="creditLimit"
              :retryCouponSerialId="pageInfo.retryCouponSerialId"
            ></unused-privilege>
          </template>
          <template v-else-if="bannerStyle === 'REFUSED_WITHDRAW'">
            <refused-withdraw />
          </template>
          <template v-else-if="bannerStyle === 'CREDIT_RESULT'">
            <refused-box
              show-place="LOAN_RESULT"
              :step="privilegeStep"
              :source='source'
              :refusedAd="refusedAd"
              :isVipValidate="refusedBoxStatus"
            ></refused-box>
          </template>
        </template>
      </template>
      <div v-else class="result-show">
        <div v-if="isKingWait" class="king-wait">
          <div class="badge">
            插队申请中
          </div>
        </div>
        <div class="animation-wapper" v-else-if="showGif">
          <lottie ref="animataion" :options="showGif"  v-on:animCreated="handleAnimation"/>
        </div>
        <h1>{{ resultStatus[statusMapping] && resultStatus[statusMapping].text }}</h1>
        <!-- 放款成功 -->
        <template v-if="statusMapping === '0'">
          <h2 class="description">已为您放款，具体以银行实际到账时间为准。</h2>
        </template>

        <!-- 放款中 -->
        <template v-if="statusMapping === '1'">
          <h2 class="loans">
            我们正在为您放款,预计两天内到账
          </h2>
          <h2 class="loans">
            为不影响放款进度,请留意接听我们的服务监督电话
          </h2>
        </template>

        <!-- 放款失败 -->
        <template v-if="statusMapping === '2'">
          <h2 class="description">
            <!-- 抱歉，由于系统异常导致放款失败， -->
            {{ result.rejectReason }}
            <br/>
            <!-- 您可重新发起提现申请；如有疑问联系客服。 -->
          </h2>
        </template>
        <div v-if="statusMapping === '2'" class="servicePhone" @click="openPhoneDialog">
          <img src="../../assets/images/call.png"/>
          <span>联系客服</span>
        </div>
        <!-- 信用不足 -->
        <template v-if="statusMapping === '3'">
          <div v-if="!isOverdue">
            <img src="./image/img_tishi.png" alt="提示" class="tips">
          </div>
          <div class="overdue" v-else>
            <div>
              <span class="left">您有逾期账单，</span>
              <span class="middle" @click="goRepayment">归还逾期账单 </span>
              <span>恢复信用值</span>
            </div>
          </div>
          <h2 class="description">{{ lockingDay | date }} 可重新提现</h2>
        </template>

        <!--提现审核中-->
        <template v-if="statusMapping === '4'">
          <p v-if="isKingWait" class="king-description">尊敬的会员，已为您启用<span>VIP专属</span>审核通道</p>
          <p v-else class="description">
            我们正在加急为您审核，请您耐心等待
          </p>
        </template>

        <!--提现审核中-->
        <template v-if="statusMapping === '5'">
          <h2 class="description" v-html="`我们正在为您放款，预计2小时内到账<br/>为不影响放款进度，请留意接听我们的服务监督电话`">

          </h2>
        </template>
        <!--提现审核中-->
        <template v-if="statusMapping === '6'">
          <h2 class="description" v-html="`抱歉，由于系统异常导致放款失败，<br/>您可重新发起提现申请；如有疑问联系客服。`">

          </h2>
        </template>
        <!--提现审核中-->
        <template v-if="statusMapping === '7'">
          <h2 class="description" v-html="`该次借款申请已关闭，您可重新发起提现申请；<br/>如有疑问联系客服。`">

          </h2>
        </template>

        <!-- 放款成功时显示 -->
        <div class="loan-info section-container" v-if="statusMapping === '0'">
          <div class="info-item">
            <p class="item-title">借款金额</p>
            <p class="item-content">{{ result.applyAmount | currency }}</p>
          </div>

          <div class="info-item">
            <p class="item-title">借款期限</p>
            <p class="item-content">{{ result.dueTime }}个月</p>
          </div>

          <div class="info-item">
            <p class="item-title">借款日期</p>
            <p class="item-content">{{ result.loanDate | date }}</p>
          </div>
        </div>
      </div>

      <nd-button class="btn loan-btn" v-if="['2','6','7'].includes(statusMapping)" @click="goWithdraw" v-stat="{ id: 10141 }">立即提现</nd-button>
      <!-- <nd-button class="btn loan-btn" v-if="statusMapping === '3' && isOverdue" @click="goRepayment">立即还款积累信用</nd-button> -->
      <!-- 确认按钮 -->
      <nd-button
        v-if="statusMapping !== '3'"
        class="btn confirm-btn line"
        :class="[{ 'btn-gutter': statusMapping === '2' || statusMapping === '3' },
                 { 'btn-low-gutter': statusMapping === '1' }]"
        @click="confirm"
      >
        {{ resultStatus[statusMapping] && resultStatus[statusMapping].btn }}
      </nd-button>

      <div
        v-if="showPrivilegeBanner"
        class="privilege-box"
        :class="{'pt400': false}"
      >
        <div
          class="privilege-content"
          :class="{ani: showPrivilegeBanner && showReviewButton}"
          data-sensors-click
          data-sensors-exposure-event-name="Element_Exposure"
          data-sensors-exposure-property-caseId="SKC_M"
        >
          <img class="box-icon" src="./image/icon_tip.png">
          您的申请暂未通过
          <template v-if="showReviewButton">
            ，<span
              class="box-strong"
              data-sensors-click
              v-stat="{id: 20294}"
              @click="jumpToKingCardPage"
            >立即重审，通过率翻倍 >></span>
          </template>
        </div>
      </div>
      <template v-if="!isQlc">
        <footer>
          <div :class="['3'].includes(statusMapping)&&'borrow-list'">
            <borrow-list status="loan" :step="privilegeStep" show-place="LOAN_RESULT" type="river_diversion" v-if="['3'].includes(statusMapping)" :source='source' show-sub show-tips show-swipe title="借款推荐" />
          </div>
        </footer>
      </template>
      <!-- 广告位 -->
      <div class="ad-container"
           data-sensors-exposure-event-name="Element_Exposure"
           v-if="statusMapping === '3' && userInfo.hasDiversion && ['UN_BUY', 'EXPIRED'].includes(privilegeUsed) && banner.jumpUrl"
      >
        <a :href="banner.jumpUrl" data-sensors-click class="ad"> <img  :src="banner.image" /> </a>
      </div>
      <nd-dialog v-model="customerShow" @confirm="callService" @close='closeDialog'>
        <div class="service-dialog">
          <div class="title">联系客服</div>
          <div class="description">拨打客服电话进行咨询</div>
          <div class="description1">客服电话：4000100008</div>
          <div class="telphone">服务时间：</div>
          <div class="telphone">周一到周五 上午9:00-12:00 下午13:30-18:00</div>
        </div>
      </nd-dialog>
      <nd-dialog
        v-model="popVisible"
        closeBtn
        :footer="false"
      >
        <div class="pop-dialog">
          <div class="title">提现绿色通道</div>
          <div class="description">已为您匹配到更多资方，提现成功率提升5倍</div>
          <div class="button-group">
            <nd-button class="continue-btn" @click="goWithdraw">继续提现</nd-button>
            <div class="giveup-btn" @click="goHome">放弃</div>
          </div>
        </div>
      </nd-dialog>
      <nd-dialog v-model="dialog4" closeBtn :footer="false">
        <div class="service-dialog3">
          <div class="description">您当前如需使用权益功能，请更新至最新版本。 您可前往「天美贷-我的」点击「版本更新」进行升级。</div>
          <div class="flex">
            <nd-button class="btn small" @click="jumpHome">立即升级</nd-button>
          </div>
        </div>
      </nd-dialog>
    </pulldown-page>
    <refused-privilege-dialog
      v-model="buyGuideVisible"
      status="loan"
      :amount="privilegeAmount"
      :price="price"
      :expirePrice="expirePrice"
      :expireDate="expireDate"
      :supplier="supplier"
      :couponInfo="couponInfo"
      @on-success="hanldeBuySuccess"
    ></refused-privilege-dialog>
    <buy-dialog-jw
      v-model="buyVisible"
      :copyUrl="payUrl"
      @on-complete="queryPrivilegeDetail"
    ></buy-dialog-jw>
    <api-sheet
      ref="apiSheet"
      :show="needApiGuideBottomSheet"
      :pageType="pageType"
      @needsShowListPop="needsShowApiListPopUp"
      @on-apiSheetClose="apiPageClose"
    />
    <nd-dialog
      class="api-list-popup"
      v-model="apiListPopVisible"
      :closeBtn="true"
      :footer="false"
    >
      <api-list-pop :items="apiListPopItems" @confirmApply="apiListPopUpApply"/>
    </nd-dialog>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { judgeClientSystem, mockHrefJump, getKey, setKey, copyToClipbord, isEmptyObject } from '@/assets/utils'
import { jsBridge, hasNativeMethod } from '@/assets/jsBridge'
import Lottie from 'vue-lottie'
import { fail, wait, success } from '@/assets/json/index'
import BorrowList from '@/components/borrow-list'
import RefusedBox from '@/components/refused-box'
import RefusedWithdraw from './components/refused-withdraw'
import UnusedPrivilege from '@/components/unused-privilege'
import RefusedPrivilegeDialog from '@/components/refused-privilege-dialog'
import BuyDialogJw from '@/components/buy-dialog-jw'
import apiPage from '../authentication/api-auth/api-page'
import apiSheet from '../authentication/api-guide-sheet.vue'
import apiListPop from '../authentication/components/api-list-pop.vue'

const PAGE_TYPE = 'WITHDRAW_REFUSAL_API_GUIDE'

// 常量定义
const RESULT_STATUS = {
  // 已放款
  '0': {
    text: '已为您放款成功！',
    class: 'success',
    btn: '返回首页'
    // description: '已为您放款，具体以银行实际到账时间为准。'
  },
  // 放款中
  '1': {
    text: '提现成功，放款中',
    class: 'wait',
    btn: '返回首页'
    // description: '我们正在为您放款，请耐心等待。等待过程中，您 可下拉刷新结果；或联系客服010-123456'
  },
  // 放款失败
  '2': {
    text: '放款失败',
    class: 'fail',
    btn: '返回首页'
    // description: '抱歉，由于系统异常导致放款失败，您可重新发起 提现申请；如有疑问联系客服XXXXX'
  },
  '3': {
    text: '信用值不足，审核失败',
    class: 'not-enough',
    btn: '返回首页'
    // description: '抱歉，由于系统异常导致放款失败，您可重新发起 提现申请；如有疑问联系客服XXXXX'
  },
  '4': {
    text: '提现审核中',
    class: 'withdraw-wait',
    btn: '返回首页'
  },
  // 专属提速通道放款中
  '5': {
    text: '专属提速通道放款中',
    class: 'withdraw-wait',
    btn: '返回首页'
  },
  // 专属提速通道放款中
  '6': {
    text: '放款失败',
    class: 'withdraw-fail',
    btn: '返回首页'
  },
  // 专属提速通道放款中
  '7': {
    text: '放款失败',
    class: 'withdraw-fail',
    btn: '返回首页'
  }
}

export default {
  name: 'withdraw-result',

  description: '提现结果',

  customReadyNotify: true,

  components: {
    'lottie': Lottie,
    'borrow-list': BorrowList,
    RefusedBox,
    RefusedWithdraw,
    UnusedPrivilege,
    RefusedPrivilegeDialog,
    BuyDialogJw,
    apiPage,
    apiSheet,
    apiListPop
  },

  data () {
    return {
      banner: {},
      couponInfo: {},
      buyVisible: false,
      payUrl: '', // 及未支付链接，传给弹窗组件
      privilegeAmount: 29.9,
      expirePrice: 0,
      expireDate: 0,
      supplier: '',
      speedMemberStatus: null,
      price: 29.9,
      privilegeUsed: 'UN_BUY',
      refusedAd: {},
      resultStatus: RESULT_STATUS,
      showGif: null,
      result: {
        applyAmt: '', // 申请金额
        applyTerm: '', // 申请期限
        approvedDate: '', // 审核日期
        createTime: '', // 提现日期
        originApprovedDate: '', // 授信通过时间
        loanDesc: '', // 结果描述
        loanStatusVoEnum: '', // 放款状态
        riskStatus: '', // 风控状态
        lockingDay: '', // 锁定日期
        tel: '',
        rejectReason: '',
        failedReason: '' // 放款失败后端返回的文案
      },
      isLoading: false,
      clipboard: null,
      customerShow: false,
      popVisible: false,
      dialog4: false, // 为了解决安卓页面兼容的问题，用户于老版本券包页面跳转及授信/提现结果页跳转进权益卡
      queryExamine: null, // 审批中轮询
      channel: this.$route.query.channel || getKey('channel') || 'official',
      source: window.location.href,
      needApiGuideBottomSheet: false, // 引导API列表弹窗
      buyGuideVisible: false, // 引导购买弹窗
      needsShowBuyGuide: false, // 是否需要显示引导购买弹窗,临时存放
      apiListPopItems: [],
      apiListPopVisible: false,
      pageType: PAGE_TYPE,
      pageInfo: null,
      goodsCd: ''
    }
  },

  computed: {
    // 放款结果映射
    statusMapping () {
      if (this.type) return this.type
      else if (this.result.usedVipAmt && this.result.loanStatusVoEnum === 'LOANING') return '5' // 专享提速通道放款中
      else if (this.result.loanStatusVoEnum === 'LOANING') return '1' // 放款中
      else if (this.result.loanStatusVoEnum === 'LOAN_PASSED') return '0' // 已放款
      else if (['APPLY_FAIL', 'LOAN_FAILURE'].includes(this.result.loanStatusVoEnum)) return '2' // 放款失败
      else if (this.result.loanStatusVoEnum === 'WITHDRAWALS_REJECTED') return '3' // 信用不足
      else if (this.result.loanStatusVoEnum === 'LOAN_AUDIT') return '4' // 提现审核中
      else if (this.result.loanStatusVoEnum === 'TIMEOUT') return '6' // 超时
      else if (this.result.loanStatusVoEnum === 'LOAN_GIVE_UP') return '7' // 放弃
      return '4'
    },
    ...mapState('withdraw', ['customerServicePhone']),

    ...mapState('activities', {
      qualificationCoupon: state => state.qualificationCoupon ? (state.qualificationCoupon[0] || {}) : {}
    }),

    ...mapState('user', {
      creditStatus: state => state.quotaInfo.creditStatus,
      creditLimit: (state) => state.quotaInfo.creditLimit,
      lockingDay: (state) => state.quotaInfo.lockingDay,
      userInfo: state => state.userInfo
    }),

    ...mapState({
      statusBarHeight: state => state.statusBarHeight
    }),

    isOverdue () {
      // 当期逾期
      return this.result.rejectReason === 'C'
    },
    privilegeStep () {
      let result = ''
      if (['UN_BUY', 'EXPIRED'].includes(this.privilegeUsed)) {
        result = 'loan'
      } else if (['UN_USE'].includes(this.privilegeUsed)) {
        result = 'loan2'
      } else if (['USED'].includes(this.privilegeUsed)) {
        result = 'loan3'
      }
      return result
    },
    // 是否展示重审横幅
    showPrivilegeBanner () {
      /*
      已购买小美VIP/小美SVIP/小美会员 且在有效期内的用户且广告位存在有效导流产品
      或
      至尊王卡资格（未购买/已失效）用户 且（运营系统未屏蔽对应权益或存在有效导流产品）时
      展示横幅
      */
      return this.statusMapping === '3' && ((this.isVipValidate && !isEmptyObject(this.refusedAd)) ||
        (
        this.hasKingCardQualifications &&
        (this.pageInfo?.showKingMember === 'Y' || !isEmptyObject(this.refusedAd))
      ))
    },
    showReviewButton () {
      // 有购买资格且运营系统未屏蔽对应权益
      return this.hasKingCardQualifications && this.pageInfo?.showKingMember === 'Y'
    },
    bannerStyle () {
      if (!this.pageInfo) { return '' }
      const {
        haveRwcmMember,
        showRwcmMember,
        haveKingMember,
        showKingMember,
        retryCouponUsed
      } = this.pageInfo
      // 提现重审卡有效期内
      const haveRwcm = haveRwcmMember === 'Y'
      // 是否展示提现重审卡权益
      const showRwcm = showRwcmMember === 'Y'
      // 至尊卡有效期内
      const haveKing = haveKingMember === 'Y'
      // 是否展示至尊卡权益
      const showKing = showKingMember === 'Y'
      // 是否已使用重审
      const couponUsed = retryCouponUsed === 'Y'
      // 有权益且运营系统未屏蔽对应权益
      const haveAndShouldShowPrivilege = (haveRwcm && showRwcm) || (haveKing && showKing)
      if (couponUsed) {
        return 'REFUSED_WITHDRAW'
      } else {
        return haveAndShouldShowPrivilege ? 'UNUSED_PRIVILEGE' : 'CREDIT_RESULT'
      }
    },
    showPrivilege () {
      if (!this.pageInfo) { return false }
      return this.pageInfo?.showRwcmMember === 'Y' || this.pageInfo?.showKingMember === 'Y'
    },
    // 是否有其他会员（vip/svip/小美会员）
    isVipValidate () {
      if (!this.pageInfo) { return false }
      return this.pageInfo?.haveOtherMember === 'Y'
    },
    // 是否有至尊卡购买资格
    hasKingCardQualifications () {
      if (!this.pageInfo) { return false }
      return this.pageInfo?.kingBuyQualification === 'Y'
    },
    refusedBoxStatus () {
      if (!this.pageInfo) { return false }
      const {
        haveRwcmMember,
        showRwcmMember,
        haveKingMember,
        showKingMember
      } = this.pageInfo
      // 授信重审卡有效期内
      const haveRwcm = haveRwcmMember === 'Y'
      // 是否展示授信重审卡权益
      const showRwcm = showRwcmMember === 'Y'
      // 至尊卡有效期内
      const haveKing = haveKingMember === 'Y'
      // 是否展示至尊卡权益
      const showKing = showKingMember === 'Y'

      if (!showRwcm && !showKing) { return true }
      if (this.hasKingCardQualifications) { return !showKing }
      if (this.isVipValidate) { return true }
      if ((!haveRwcm || !showRwcm) && (!haveKing || !showKing)) { return true }
      // if (((haveRwcm && !showRwcm) || (haveKing && !showKing)) && retryCouponUsed === 'N') {
      //   return true
      // }
      return false
    },
    isKingWait () {
      if (!this.pageInfo) { return false }
      return this.pageInfo?.haveKingMember === 'Y'
    }
  },
  watch: {
    statusMapping (value, preValue) {
      if (!['1', '4', '5'].includes(value)) {
        if (this.queryExamine) {
          clearInterval(this.queryExamine)
          let obj = { '0': 'LOAN_PASSED', '1': 'LOANING', '2': 'LOAN_FAILURE', '3': 'WITHDRAWALS_REJECTED', '4': 'LOAN_AUDIT', '5': 'LOANING', '6': 'TIMEOUT', '7': 'LOAN_GIVE_UP' }
          this.result.loanStatusVoEnum = obj[preValue]
          if (preValue === '5') { this.result.usedVipAmt = true }
          window.location.reload()
        }
      }
    }
  },
  beforeRouteLeave (to, form, next) {
    clearInterval(this.queryExamine)
    next((vm) => {
    })
  },
  async created () {
    const hasApiList = await this.getApiApplyList()
    // 有一键申请数据，跳转到申请页面
    if (hasApiList) {
      return
    }
    const userHasDiversion = await this.checkUserHasDiversion()
    // 非导流用户，跳转清洁版
    if (!userHasDiversion) {
      return
    }

    this.type = this.$route.query.type || ''
    if (this.$route.query.loanApplyNo === 'false') {
      this.$bus.$emit('ready')
    } else {
      try {
        const res = await this.queryDiversionProduct()
        if (res) return
        await this.getLoanResult()
        await this.getLimitX({ loanPlatform: 'TMD' })
        this.$sensors.track('Results_Page_View', { page_status: this.result.loanStatusVoEnum, additinal_status: this.privilegeStep })
        this.$bus.$emit('ready')
      } catch (exp) {
        this.$bus.$emit('error')
      }
    }
    this.getBanner()
  },

  methods: {
    ...mapActions('withdraw', [
      'getLoanResultX'
    ]),

    ...mapActions('user', ['getLimitX', 'getUserInfoX', 'getBorrowList', 'showStatusX', 'apiApplyListX', 'adBanner', 'getBizTag']),
    ...mapActions('authentication', ['getApiListPageShowType', 'getResultPageInfo']),
    ...mapActions('vip', [
      'queryDetailX'
    ]),
    /**
     * 判断是否有一键申请的数据
     * 有跳转到一键申请页面 return
     * 没有就在结果页走老流程
     */
    async getApiApplyList () {
      const { success, data } = await this.apiApplyListX({
        pageType: this.pageType
      })
      if (success && data && data.configs && data.configs.length) {
        const { success, data } = await this.getApiListPageShowType()
        if (success) {
          this.needApiGuideBottomSheet = data.status
          if (!data.status) {
            this.setBuyGuideVisible()
          }
          return false
        } else {
          this.$router.replace(`/authentication/api-page?pageType=${this.pageType}`)
          return true
        }
      }
      return false
    },
    async checkIsPasscard () {
      const [bizTagRes, showStatusRes] = await Promise.all([
        this.getBizTag(),
        this.showStatusX({
          rightsType: 'PASS'
        })
      ])
      if (bizTagRes.success && showStatusRes.success) {
        const isPasscard = ['HAVE_QUALIFICATION'].includes(bizTagRes.data.passCardTag) && showStatusRes.data
        if (isPasscard) {
          this.$router.replace({
            path: '/withdraw/result3'
          })
        }
        return isPasscard
      }
      return false
    },
    // 检查是否是导流用户
    async checkUserHasDiversion () {
      // const isPassCardRefused =
      const userInfo = await this.getUserInfoX({ forceUpdate: true })
      if (!userInfo.hasDiversion) {
        this.$router.replace({
          path: '/withdraw/result2',
          query: {
            loanApplyNo: this.$route.query.loanApplyNo
          }
        })
      }
      // 已购买授信重审卡
      if (userInfo.privilegeCardDetail && userInfo.privilegeCardDetail.rwCard) {
        const { rwCard } = userInfo.privilegeCardDetail
        if (rwCard.status === 'SUC_USE') {
          this.privilegeUsed = 'USED'
        } else if (['OVERDUE', 'USE_OVER'].includes(rwCard.status)) {
          this.privilegeUsed = 'EXPIRED'
        } else {
          this.privilegeUsed = 'UN_USE'
        }
      }
      return userInfo.hasDiversion
    },
    async getBanner () {
      const { success, data } = await this.adBanner({
        riskBannerType: 'WITHDRAWAL_REJECTION'
      })
      if (success) {
        this.banner = data || {}
      }
    },
    navigateTo (path, replace) {
      if (replace) {
        this.$router.replace(path)
      } else {
        this.$router.push(path)
      }
    },
    // 返回首页
    navigateToHome () {
      this.backHome()
    },
    // 获取特权卡详情
    async queryPrivilegeDetail () {
      const { success, data } = await this.queryDetailX({
        goodsCd: 'SKC_M'
      })
      if (success) {
        this.privilegeAmount = data.discountPrice
        this.expirePrice = data.expirePrice
        this.expireDate = data.expireDate
        this.supplier = data.goodsSupplier
        this.speedMemberStatus = data.memberStatus
        this.price = data.price
        this.goodsCd = data.goodsCd
        this.couponInfo = data.couponInfo
      }
    },
    // 跳转首页
    jumpHome () {
      this.dialog4 = false
      if (hasNativeMethod('navigateTo')) {
        jsBridge('navigateTo', { path: 'login', exitCurrent: true })
      }
    },
    handleAnimation (anim) {
      console.log('handleAnimation')
      this.anim = anim
    },
    // 下拉刷新
    pulldown () {
      window.location.reload()
    },
    // 处理接口对应的gif值
    changeGif (title) {
      let value = ''
      if (this.type) value = this.type
      else if (this.result.usedVipAmt && this.title === 'LOANING') return '5' // 专享提速通道放款中
      else if (title === 'LOANING') value = '1' // 放款中
      else if (title === 'LOAN_PASSED') value = '0' // 已放款
      else if (['LOAN_FAILURE', 'APPLY_FAIL'].includes(title)) value = '2' // 放款失败
      else if (title === 'WITHDRAWALS_REJECTED') value = '3' // 信用不足
      else if (title === 'LOAN_AUDIT') value = '4' // 提现审核中
      else if (title === 'TIMEOUT') value = '6' // 超时
      else if (title === 'LOAN_GIVE_UP') value = '7' // 放弃
      else value = '1'
      this.dealGif(value)
    },
    // 判断gif展示哪张图片
    dealGif (value) {
      let arr = {}
      if (value === '0') {
        arr = { animationData: success, loop: false }
      } else if (['1', '4', '5'].includes(value)) {
        arr = { animationData: wait }
      } else {
        arr = { animationData: fail, loop: false }
      }
      this.showGif = arr
    },
    confirm () {
      // 额度有效跳转到提现页
      if (this.statusMapping === '3' && ['CREDIT_SUCCESS', 'LOAN_INFO'].includes(this.creditStatus)) {
        this.goWithdraw()
      } else {
        this.backHome()
      }
    },

    // 拨打电话
    callService () {
      this.$report({
        id: 10061,
        args: {
          position: 'page_reconciliation',
          target: this.customerServicePhone
        }
      })
      mockHrefJump(`tel:4000100008`)
    },

    closeDialog () {
      this.$report({
        id: 10062,
        args: {
          postion: 'page_reconciliation'
        }
      })
    },
    // 获取导流产品信息
    async queryDiversionProduct () {
      const { success, data } = await this.getBorrowList({
        showPlace: 'LOAN_RESULT',
        queryBanner: true,
        version: 'V2'
      })
      if (success) {
        if (data.showPlaceSwitch !== 'Y') {
          // 如果该页面被禁用，则跳转清洁版
          this.$router.replace(`/withdraw/result2?loanApplyNo=${this.$route.query.loanApplyNo}`)
          return true
        }
        const { bannerConfigsV2 } = data
        this.refusedAd = bannerConfigsV2 && bannerConfigsV2.length && bannerConfigsV2[0] ? bannerConfigsV2[0].config : {}
        if (this.refusedAd && this.refusedAd.configId) {
          this.$report({
            id: 10002,
            args: { position: 'banner', target: this.refusedAd.configId, screen: 'loan' }
          })
        }
      }
    },
    async getLoanResult () {
      const response = await this.getLoanResultX({ loanApplyNo: this.$route.query.loanApplyNo })
      if (response.success) {
        this.result = response.data || {}
        // 业务提额流程
        if (this.isNotEmptyString(this.result.bizAdjustAmountLoanSerialNo)) {
          this.$router.replace({
            path: '/withdraw/biz-limit-up-confirm',
            query: {
              loanSerialNo: this.result.bizAdjustAmountLoanSerialNo
            }
          })
          return
        }
        if (['LOAN_FAILURE', 'APPLY_FAIL', 'WITHDRAWALS_REJECTED'].includes(this.result.loanStatusVoEnum) && this.result.passCardProcess === 'Y') {
          // pass卡放款失败，跳转到pass卡放款失败页面
          this.$router.replace(`/withdraw/refused/pass?loanApplyNo=${this.$route.query.loanApplyNo}`)
          return
        } else if (this.result.pop36) {
          this.popVisible = true
        }
        if (['1', '4', '5'].includes(this.statusMapping) && !this.queryExamine) {
          this.queryExamine = setInterval(async () => {
            await this.getLoanResult()
          }, 10000)
        } else {
          this.getLimitX({ loanPlatform: 'TMD' })
        }
        this.changeGif(this.result.loanStatusVoEnum)
        const mapping = {
          'LOAN_PASSED': 1,
          'LOANING': 2,
          'LOAN_FAILURE': 3,
          'APPLY_FAIL': 3,
          'WITHDRAWALS_REJECTED': 3,
          'LOAN_AUDIT': 4,
          'LOAN_WAIT_VIP': 4
        }

        if (this.result.loanStatusVoEnum === 'WITHDRAWALS_REJECTED') {
          // 风控拒绝
          // 是pass卡，跳转pass卡拒绝页面
          const isPasscard = await this.checkIsPasscard()
          if (isPasscard) {
            return
          }
        }


        this.$report({
          id: 10114,
          args: {
            status: mapping[this.result.loanStatusVoEnum] || 5,
            message: response.msg
          }
        })
      } else {
        throw new Error(response.msg)
      }

      await this.getResultPageInfoX()
      await this.checkIfNeedsShowPrivilegePop()
    },
    async checkIfNeedsShowPrivilegePop () {
      // 只有接口返回的是true才有这个逻辑，否则不会显示
      if (this.showPrivilege) {
        // 显示特权卡的弹窗（正常提现流程过来不要弹窗，即noDialog === T）
        if (this.statusMapping === '3' && this.userInfo.hasDiversion && ['UN_BUY', 'EXPIRED'].includes(this.privilegeUsed) && this.$route.query.noDialog !== 'T') {
          await this.queryPrivilegeDetail()
          this.$report({
            id: 20999,
            args: {
              position: 'loan_review_buy',
              type: this.supplier
            }
          })
          // 不在小美会员 小美vip svip 特权卡有效期内
          if (this.isIntervalDay('buyGuideVisible-withdraw', 1)) {
            this.$nextTick(() => {
              this.needsShowBuyGuide = this.hasKingCardQualifications && this.pageInfo?.showKingMember === 'Y'
              if (!this.needApiGuideBottomSheet && !this.buyGuideVisible) {
                this.setBuyGuideVisible()
              }
              this.$sensors.track('PopupDisplay', { msg_name: this.goodsCd })
            })
          }
        }
      }
    },
    goHome () {
      if (hasNativeMethod('exit') && judgeClientSystem() !== 'IOS') {
        jsBridge('exit')
      } else {
        jsBridge('navigateTo', { path: 'home', exitCurrent: true })
        if (getKey('channel') === 'API-XHQB') {
          window.location.href = getKey('successUrl')
        } else {
          this.$router.push('/')
        }
      }
    },

    goWithdraw () {
      this.$router.push('/middle/limit')
    },
    goRepayment () {
      if (hasNativeMethod('navigateTo') && judgeClientSystem() !== 'IOS') {
        jsBridge('navigateTo', { path: 'repayment', exitCurrent: true })
      } else {
        this.$router.push({
          path: '/repayment',
          query: { type: 'TMD' }
        })
      }
    },

    // 打开客服电话
    openPhoneDialog () {
      this.customerShow = true
    },

    // 关闭客服电话
    closePhoneDialog () {
      this.customerShow = false
    },
    // 下单成功
    hanldeBuySuccess (payUrl) {
      this.payUrl = payUrl
      copyToClipbord(this.payUrl)
      this.buyVisible = true
      this.handleBuyPolling()
    },
    // 购买弹窗后轮询(轮询10次或状态已购买则不再轮询)
    handleBuyPolling () {
      let times = 1
      const timer = setInterval(() => {
        if (times > 10 || this.speedMemberStatus === 'NORMAL') {
          clearInterval(timer)
        } else {
          times += 1
          this.queryPrivilegeDetail()
        }
      }, 30 * 1000)
    },
    needsShowApiListPopUp (items) {
      this.apiListPopVisible = true
      this.apiListPopItems = items
    },
    apiListPopUpApply () {
      this.apiListPopVisible = false
      this.$refs.apiSheet.confirmApply(this.apiListPopItems)
    },
    async getResultPageInfoX () {
      const { success, data } = await this.getResultPageInfo({
        page: 'LOAN'
      })
      if (success) {
        this.pageInfo = data || {}
        return
      }
      this.pageInfo = {}
    },
    apiPageClose () {
      this.needApiGuideBottomSheet = false
      if (!this.pageInfo) {
        return
      }
      setTimeout(() => {
        this.setBuyGuideVisible()
      }, 500)
    },
    setBuyGuideVisible () {
      this.buyGuideVisible = this.needsShowBuyGuide
      setKey('buyGuideVisible-withdraw', Date.now())
    }

  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.ad-container {
  padding: 20px;

  img {
    width: 100%;
  }
}
.pt400{
  padding-top: 400px !important;
}
.loans{
    font-size: 30px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    font-weight: 400;
    margin-top:8px !important;
}
.wrapper {
    height: 100%;
}
.withdraw-result {
  position: relative;
  min-height: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  overflow: auto;

  .refresh{
    color: #fff;
  }

  .navigation-refresh {
    position: absolute;
    top: 30px;
    right: 0;
    left: 0;
  }

  .btn {
    width: 320px;
    height: 80px;
    line-height: 80px;
    font-size: 32px;
    margin: 80px auto 0;

    & + .btn {
        margin-top: 30px;
    }
  }

  .section-container {
    width: 690px;
    height: 230px;
    margin: 63px auto 0;
    background: rgba(250,250,250,1);
    border-radius: 20px;

    &.no-container {
      background-color: transparent;
      border-radius: 0;
      width: unset;
      height: unset;
      margin-top: 70px;
    }
  }

  .loan-info {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 45px 40px;

    .info-item {
      flex: 1;
      display: flex;
      flex-direction: row;
      text-align: center;
      .item-title {
          width: 160px;
          font-weight: 400;
      }
      .item-content {
          flex: 1;
          font-weight: 500;
          font-family:DIN-Medium,DIN;
      }
      p {
          font-family: 'PingFangSC-Medium';
          font-size: 28px;
          text-align: left;
      }
    }
  }

  .loan-step {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;

    .step {
      text-align: center;
      overflow: hidden;
      flex: 1;

      .custom-icon {
        display: block;
        background-size: 100% 100%;
        margin: 0 auto;

        &.step-status {
          width: 52px;
          height: 52px;
          /*background-image: url(../../assets/img/withdraw-result/procedure_icon02.png);*/
          position: relative;

          // &.compelete {
              /*background-image: url(../../assets/img/withdraw-result/procedure_icon01.png);*/
          // }

          &::before, &::after {
            content: "";
            display: block;
            position: absolute;
            height: 2px;
            top: 50%;
            margin-top: 1px;
            background-color: #FFF;
          }

          &::before {
            left: -100px;
            right: 60px;
          }

          &::after {
            left: 60px;
            right: -100px;
          }

          &:last-child {
            &::after {
                width: 0;
            }
          }
        }
      }

      &:first-child {
        .custom-icon {
          &.step-status {
            &::before {
                width: 0;
            }
          }
        }
      }

      &:last-child {
        .custom-icon {
          &.step-status {
            &::after {
                width: 0;
            }
          }
        }
      }

      p {
        font-size: 30px;
        font-family: 'PingFangSC-Medium';
        font-weight: 500;

        &.date {
          font-size: 22px;
          font-family: 'PingFangSC-Regular';
          font-weight: 400;
        }
      }
    }

    .qrcode {
        height: 377px;
        width: 377px;
    }
  }

  .king-wait {
    width: 162px;
    height: 174px;
    margin: 0 auto;
    background: url(./image/img_wait_clean_king.png) no-repeat;
    background-size: 100%;
    margin-bottom: 20px;
    .badge {
      width: 150px;
      height: 46px;
      background: #FFE2BD;
      border-radius: 100px 100px 100px 0px;
      font-size: 24px;
      font-weight: 400;
      color: #763E12;
      line-height: 46px;
      text-align: center;
      position: absolute;
      top: 189px;
      left: 434px;
    }
  }
  .result-show {
    padding-top: 220px;
    flex-grow: 1;

    .animation-wapper {
      height: 210px;
      width: 210px;
      margin: 0 auto;
    }

    p.king-description {
      margin-top: 15px;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      text-align: center;
      > span {
        color: #FF4633
      }
    }

    .description {
      width: 100%;
      padding: 0 63px;
      color: rgba(102,102,102,1);
      margin: 15px 0 0;
      font-size: 26px;
      text-align: center;
      span {
          color: @theme;
      }
    }
    .tips {
      width: 600px;
      height: 91px;
      margin-left: 75px;
      margin-top: 19px;
    }
    .overdue {
      margin: 19px auto 0;
      width: 530px;
      height: 90px;
      background: #F7F7F7;
      border-radius: 20px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FF4633;
      line-height: 33px;
      text-align: center;
      display: flex;
      flex-direction: row;
      align-items: center;
      img {
          margin-left: 15px;
          width: 32px;
          height: 32px;
      }
      div {
          margin-left: 15px;
          .middle {
              text-decoration: underline;
          }
      }
    }
    .custom-icon {
      display: block;
      width: 174px;
      height: 174px;
      margin-left: 280px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }

    h1 {
      font-family: PingFangSC-Medium,PingFang SC;
      font-weight: 500;
      font-size: 42px;
      margin-top: 50px;
      line-height: 59px;
      text-align: center;
      color:rgba(51,51,51,1);
    }

    h2 {
      font-family: 'PingFangSC-Regular';
      font-weight: 400;
      font-size: 28px;
      line-height: 36px;
      margin: 20px 50px 0;
    }
  }

    .servicePhone {
      position: absolute;
      display: flex;
      justify-content:space-between;
      align-items: center;
      top: 128px;
      right:0;
      width: 200px;
      height: 60px;
      background: #FAFAFA;
      border-radius: 40px;
      border: 1px solid #EEEEEE;
      padding:0 23px 0 28px;
      img{
        width: 29px;
        height:29px;
        span {
          width: 104px;
          height: 37px;
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 37px;
        }
      }
    }
    .service-dialog {
      padding: 10px 48px 80px;
      font-family: PingFangSC-Regular,PingFang SC;

      .title {
        font-size: 42px;
        height: 72px;
        line-height: 72px;
        font-family: PingFangSC-Semibold,PingFang SC;
        font-weight: 600;
      }

      .description {
        font-size: 30px;
        height: 32px;
        line-height: 32px;
        margin-top: 22px;
        font-weight: 400;
      }
      .description1{
        font-size: 30px;
        height: 32px;
        line-height: 32px;
        margin: 12px auto 12px;
        font-weight: 400;
      }
      .telphone {
        font-size: 24px;
        height: 40px;
        line-height: 40px;
        margin-top: 2px;
        font-weight: 400;
        color: @fc3;
      }
    }
    .service-dialog3{
      text-align: left;
      padding: 0 48px 38px;
      .description {
        margin-top:31px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }
      .thick{
        font-weight: 700 !important;
      }
      .btn {
        width: 300px;
        height: 80px;
        line-height: 80px;
        margin:40px auto 0;
      }
      .grey{
        background:white;
        color:#333;
        border:1px solid #333;
        margin:20px auto 0 !important;
      }
    }
    .activity-container {
      display: flex;
      align-items: center;
      width: 672px;
      height: 140px;
      padding-left: 30px;
      padding-right: 30px;
      margin: 70px auto 60px;
      border-radius: 20px;
      background: linear-gradient(
        90deg,
        rgba(255,179,92,1) 0%,
        rgba(253,122,22,1) 100%
      );
      .logo {
        width: 80px;
        height: 80px;
        margin-right: 20px;
      }
      .text {
        flex: 1;
        > h1 {
            font-size: 30px;
            color: #FFFFFF;
            line-height: 42px;
        }
        > p {
            font-size: 24px;
            color: #FFFFFF;
            line-height: 33px;
        }
      }
      .button {
        width: 160px;
        height: 60px;
        line-height: 60px;
        background: transparent;
        font-size: 28px;
        border-radius: 10px;
        border:1px solid rgba(255,255,255,1);
      }
    }
    .privilege-box{
      .privilege-content{
        width: 670px;
        height: 70px;
        background: #FF4633;
        border-radius: 16px;
        display: flex;
        align-items: center;
        padding: 0 10px;
        margin: 18px auto 20px;
        font-size: 28px;
        color: #fff;
        &.ani{
          animation: btnScale 1s linear infinite;
        }
        .box-icon{
          width: 40px;
          height: 40px;
          margin-right: 15px;
        }
        .box-strong{
          font-weight: bold;
          color: #FFF56A;
        }
      }
    }
    footer{
      // position: absolute;
      // bottom:90px;
      // left:40px;
      margin:auto;
      padding-bottom:20px;
      .mt180{
        margin-top:180px;
      }
      .mt250{
        margin-top:250px;
      }
      .borrow-list{
        min-height: 180px;
      }
      .footer-img{
        display:block;
        margin:20px auto 0;
        width: 670px;
        height:170px;
      }
    }
  .pop-dialog{
      padding: 35px;
      .title{
        font-size: 40px;
        font-weight: bold;
        text-align: center;
      }
      .description{
        font-size: 28px;
        margin-top: 30px;
      }
      .button-group{
        margin-top: 50px;
        text-align: center;
        .continue-btn{
          width: 340px;
          margin: 0 auto;
        }
        .giveup-btn{
          display: inline-block;
          font-size: 30px;
          margin-top: 30px;
        }
      }
  }
}
/deep/.api-list-popup {
  .nd-dialog{
    z-index: 9999 !important;
  }
  .nd-mask {
    z-index: 4000 !important;
  }
}
</style>

<style lang="less">
@import "../../assets/less/mixin.less";

    .withdraw-result {
        .van-pull-refresh__track {
            display: flex;
            flex-direction: column;
            width: 100%;
        }
        .van-pull-refresh__loading {
            color: #fff;
            .van-loading {
                color: #fff!important;
            }
        }
    }
</style>
